import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

type UiState = {
  hoursView: 'dashboard' | 'grid'
  setHoursView: (view: 'dashboard' | 'grid') => void
  hourEditorFormV2: boolean
  setHourEditorFormV2: (useV2: boolean) => void
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      hoursView: 'grid',
      setHoursView: (view) => set({ hoursView: view }),
      hourEditorFormV2: false,
      setHourEditorFormV2: (useV2) => set({ hourEditorFormV2: useV2 }),
    }),
    {
      name: 'ui-preferences-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
